import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "application-confirm-container mt-8 ml-8 mr-8 mb-16 text-gray-333" }
const _hoisted_2 = { class: "page-title font-bold text-2xl" }
const _hoisted_3 = { class: "page-content w-full" }
const _hoisted_4 = { class: "grid justify-center" }
const _hoisted_5 = { class: "items-center flex justify-end mr-12 mb-5" }
const _hoisted_6 = { class: "flex items-center mb-5" }
const _hoisted_7 = { class: "inline-flex items-center" }
const _hoisted_8 = { class: "mr-3" }
const _hoisted_9 = { class: "flex items-center col-start-2 mb-2" }
const _hoisted_10 = { class: "inline-flex items-center" }
const _hoisted_11 = { class: "mr-3" }
const _hoisted_12 = { class: "items-center flex justify-end mr-12 mb-5" }
const _hoisted_13 = { class: "flex items-center mb-5" }
const _hoisted_14 = { class: "inline-flex items-center" }
const _hoisted_15 = { class: "mr-3" }
const _hoisted_16 = { class: "flex items-center col-start-2 mb-3" }
const _hoisted_17 = { class: "inline-flex items-center" }
const _hoisted_18 = { class: "mr-3" }
const _hoisted_19 = { class: "flex items-center justify-end mr-12 mb-3" }
const _hoisted_20 = { class: "w-64 mb-3" }
const _hoisted_21 = { class: "flex items-center justify-end mr-12 mb-3" }
const _hoisted_22 = { class: "w-64 mb-3" }
const _hoisted_23 = { class: "flex items-center justify-end mr-12 mb-6" }
const _hoisted_24 = { class: "w-64 mb-6" }
const _hoisted_25 = { class: "flex justify-end mr-12 mb-8" }
const _hoisted_26 = { class: "flex ml-2" }
const _hoisted_27 = { class: "flex justify-end mr-12" }
const _hoisted_28 = { class: "flex ml-2" }
const _hoisted_29 = { class: "flex mt-4 mb-2" }
const _hoisted_30 = { class: "w-1/2 justify-end flex" }
const _hoisted_31 = { class: "w-1/2 justify-end flex" }
const _hoisted_32 = { class: "flex items-center" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "status--icon mr-2 rounded" }, null, -1)
const _hoisted_34 = { class: "text-center" }
const _hoisted_35 = { class: "text-center" }
const _hoisted_36 = { class: "text-center" }
const _hoisted_37 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")
  const _component_Select = _resolveComponent("Select")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Button = _resolveComponent("Button")
  const _component_Table = _resolveComponent("Table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('applicationHistory')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.t('applicationDate')), 1),
        _createVNode("div", _hoisted_6, [
          _createVNode("label", _hoisted_7, [
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchParams.applicationDate = $event)),
              value: 0,
              name: "applicationDate",
              type: "radio",
              class: "h-4 w-4 border-gray-300 mr-3 radio",
              checked: ""
            }, null, 512), [
              [_vModelRadio, _ctx.searchParams.applicationDate]
            ]),
            _createVNode("span", _hoisted_8, _toDisplayString(_ctx.t('monthDesignation')), 1)
          ]),
          _createVNode("div", null, [
            _createVNode(_component_DatePicker, {
              width: "120",
              type: "month",
              disabled: _ctx.searchParams.applicationDate !== 0
            }, null, 8, ["disabled"])
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("label", _hoisted_10, [
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchParams.applicationDate = $event)),
              value: 1,
              name: "applicationDate",
              type: "radio",
              class: "h-4 w-4 border-gray-300 mr-3 text-green-500 radio"
            }, null, 512), [
              [_vModelRadio, _ctx.searchParams.applicationDate]
            ]),
            _createVNode("span", _hoisted_11, _toDisplayString(_ctx.t('specifyThePeriod')), 1)
          ]),
          _createVNode("div", null, [
            _createVNode(_component_DatePicker, {
              width: "240",
              type: "date",
              "is-range": "",
              format: "YYYY/MM/DD",
              disabled: _ctx.searchParams.applicationDate !== 1
            }, null, 8, ["disabled"])
          ])
        ]),
        _createVNode("div", _hoisted_12, _toDisplayString(_ctx.t('applicationTargetDate')), 1),
        _createVNode("div", _hoisted_13, [
          _createVNode("label", _hoisted_14, [
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchParams.applicationTargetDate = $event)),
              value: 0,
              name: "applicationTargetDate",
              type: "radio",
              class: "h-4 w-4 border-gray-300 focus:from-black mr-3 text-green-500 radio",
              checked: ""
            }, null, 512), [
              [_vModelRadio, _ctx.searchParams.applicationTargetDate]
            ]),
            _createVNode("span", _hoisted_15, _toDisplayString(_ctx.t('monthDesignation')), 1)
          ]),
          _createVNode("div", null, [
            _createVNode(_component_DatePicker, {
              width: "120",
              type: "month",
              disabled: _ctx.searchParams.applicationTargetDate !== 0
            }, null, 8, ["disabled"])
          ])
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("label", _hoisted_17, [
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchParams.applicationTargetDate = $event)),
              value: 1,
              name: "applicationTargetDate",
              type: "radio",
              class: "h-4 w-4 border-gray-300 focus:ring-2 focus:focus-radio mr-3 radio"
            }, null, 512), [
              [_vModelRadio, _ctx.searchParams.applicationTargetDate]
            ]),
            _createVNode("span", _hoisted_18, _toDisplayString(_ctx.t('specifyThePeriod')), 1)
          ]),
          _createVNode("div", null, [
            _createVNode(_component_DatePicker, {
              width: "240",
              type: "date",
              "is-range": "",
              format: "YYYY/MM/DD",
              disabled: _ctx.searchParams.applicationTargetDate !== 1
            }, null, 8, ["disabled"])
          ])
        ]),
        _createVNode("div", _hoisted_19, _toDisplayString(_ctx.t('affiliationOrganization')), 1),
        _createVNode("div", _hoisted_20, [
          _createVNode(_component_Select, {
            "options-select": _ctx.organizationOption,
            "item-text": "text",
            "model-value": "0"
          }, null, 8, ["options-select"])
        ]),
        _createVNode("div", _hoisted_21, _toDisplayString(_ctx.t('director')), 1),
        _createVNode("div", _hoisted_22, [
          _createVNode(_component_Select, {
            "options-select": _ctx.directorOption,
            "item-text": "text",
            "model-value": "0"
          }, null, 8, ["options-select"])
        ]),
        _createVNode("div", _hoisted_23, _toDisplayString(_ctx.t('workingStyle')), 1),
        _createVNode("div", _hoisted_24, [
          _createVNode(_component_Select, {
            "options-select": _ctx.workingStyleOption,
            "item-text": "text",
            "model-value": "0"
          }, null, 8, ["options-select"])
        ]),
        _createVNode("div", _hoisted_25, _toDisplayString(_ctx.t('applicationType2')), 1),
        _createVNode("div", _hoisted_26, [
          _createVNode(_component_Checkbox, {
            class: "mr-5",
            "option-checkbox": { label: _ctx.t('engravingApplication') }
          }, null, 8, ["option-checkbox"]),
          _createVNode(_component_Checkbox, {
            class: "mr-5",
            "option-checkbox": { label: _ctx.t('vacationRequest') }
          }, null, 8, ["option-checkbox"]),
          _createVNode(_component_Checkbox, {
            class: "mr-5",
            "option-checkbox": { label: _ctx.t('disabilityApplication') }
          }, null, 8, ["option-checkbox"]),
          _createVNode(_component_Checkbox, {
            class: "mr-5",
            "option-checkbox": { label: _ctx.t('holidayCommutingApplication') }
          }, null, 8, ["option-checkbox"]),
          _createVNode(_component_Checkbox, {
            class: "mr-5",
            "option-checkbox": { label: _ctx.t('transferApplication') }
          }, null, 8, ["option-checkbox"]),
          _createVNode(_component_Checkbox, {
            class: "mr-5",
            "option-checkbox": { label: _ctx.t('waitingAllowanceApplication') }
          }, null, 8, ["option-checkbox"])
        ]),
        _createVNode("div", _hoisted_27, _toDisplayString(_ctx.t('status')), 1),
        _createVNode("div", _hoisted_28, [
          _createVNode(_component_Checkbox, {
            class: "mr-5",
            "option-checkbox": { label: _ctx.t('waitingForPrimaryApproval') }
          }, null, 8, ["option-checkbox"]),
          _createVNode(_component_Checkbox, {
            class: "mr-5",
            "option-checkbox": { label: _ctx.t('waitingForSecondApproval') }
          }, null, 8, ["option-checkbox"]),
          _createVNode(_component_Checkbox, {
            class: "mr-5",
            "option-checkbox": { label: _ctx.t('remand') }
          }, null, 8, ["option-checkbox"]),
          _createVNode(_component_Checkbox, {
            class: "mr-5",
            "option-checkbox": { label: _ctx.t('completion') }
          }, null, 8, ["option-checkbox"])
        ])
      ]),
      _createVNode("div", _hoisted_29, [
        _createVNode("div", _hoisted_30, [
          _createVNode(_component_Button, { class: "btn-search btn-light-blue" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('search')), 1)
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_31, [
          _createVNode(_component_Button, { class: "btn-export btn-light-blue" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('export')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", null, [
        _createVNode(_component_Table, {
          data: _ctx.applicationHistoryData,
          headers: _ctx.applicationHistoryHeaders
        }, {
          status: _withCtx(({ item }) => [
            _createVNode("div", _hoisted_32, [
              _hoisted_33,
              _createVNode("div", null, _toDisplayString(item.status), 1)
            ])
          ]),
          applicationDate: _withCtx(({ item }) => [
            _createVNode("div", _hoisted_34, _toDisplayString(item.applicationDate), 1)
          ]),
          applicationType2: _withCtx(({ item }) => [
            _createVNode("div", _hoisted_35, _toDisplayString(item.applicationType2), 1)
          ]),
          targetDate: _withCtx(({ item }) => [
            _createVNode("div", _hoisted_36, _toDisplayString(item.targetDate), 1)
          ]),
          acknowledgementTimeOfDay: _withCtx(({ item }) => [
            _createVNode("div", _hoisted_37, _toDisplayString(item.acknowledgementTimeOfDay), 1)
          ]),
          _: 1
        }, 8, ["data", "headers"])
      ])
    ])
  ]))
}